import { z } from "zod";

export const IntakeViewerSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  hasAdminAccess: z.boolean(),
  hasDepartmentAccess: z.boolean(),
  hasBusinessUnitAccess: z.boolean(),
  approverGroups: z.array(z.object({ id: z.string(), name: z.string() })),
  approverDepartments: z.array(z.object({ id: z.string(), name: z.string() })),
  approverBusinessUnits: z.array(
    z.object({ id: z.string(), name: z.string() }),
  ),
  departments: z.array(z.object({ id: z.string(), name: z.string() })),
  businessUnits: z.array(z.object({ id: z.string(), name: z.string() })),
  delegateApprover: z.boolean(),
  isMention: z.boolean(),
});

export type IntakeViewer = z.infer<typeof IntakeViewerSchema>;
